import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Watch = createReactComponent("Watch", ["svg", defaultAttributes, [["circle", {
  cx: "12",
  cy: "12",
  r: "7",
  key: "f8eh5q"
}], ["polyline", {
  points: "12 9 12 12 13.5 13.5",
  key: "x5elnt"
}], ["path", {
  d: "M16.51 17.35l-.35 3.83a2 2 0 01-2 1.82H9.83a2 2 0 01-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 019.83 1h4.35a2 2 0 012 1.82l.35 3.83",
  key: "vbew3j"
}]]]);
export default Watch;